import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const fetchProducts = async (category, opts = {}) => {
    const params = {};
    if (category && category !== "all") params.category = category;
    if (opts.section && opts.section !== "all") params.section = opts.section;
    const { data } = await apiClient.get("/products", { params });
    return data;
};

export const fetchFeaturedProducts = async () => {
    const { data } = await apiClient.get("/products", { params: { featured: true } });
    return data;
};

export const fetchProductBySlug = async (slug) => {
    const { data } = await apiClient.get(`/products/${slug}`);
    return data;
};

export const fetchCategories = async () => {
    const { data } = await apiClient.get("/categories");
    return data.categories;
};

export const fetchLookbook = async () => {
    const { data } = await apiClient.get("/lookbook");
    return data;
};

export const fetchReviews = async (slug) => {
    const { data } = await apiClient.get(`/products/${slug}/reviews`);
    return data;
};

export const submitReview = async (slug, payload) => {
    const { data } = await apiClient.post(`/products/${slug}/reviews`, payload);
    return data;
};

export const fetchJournal = async () => {
    const { data } = await apiClient.get("/journal");
    return data;
};

export const fetchJournalEntry = async (slug) => {
    const { data } = await apiClient.get(`/journal/${slug}`);
    return data;
};

export const fetchStockists = async () => {
    const { data } = await apiClient.get("/stockists");
    return data.stockists;
};

export const subscribeNewsletter = async (email) => {
    const { data } = await apiClient.post("/newsletter", { email });
    return data;
};

export const createCheckoutSession = async ({ items, origin_url, email }) => {
    const { data } = await apiClient.post("/checkout/session", { items, origin_url, email });
    return data;
};

export const getCheckoutStatus = async (sessionId) => {
    const { data } = await apiClient.get(`/checkout/status/${sessionId}`);
    return data;
};
